// removed by extract-text-webpack-plugin
module.exports = {"boxCalendar":"_1f1QwwQ8RlfApCVQxdClW3","headerCalendar":"vH0oxtu0eUFDaR12LLKro","headerTitle":"_1BZT62BveJVob60_dhgUyP","arrows":"_2Md6r3eTidxHJg6PJ7OOBm","calendar":"_2MmFndKPozislfXXa6Ks3K","current":"_1dfK67gzJPPyL4uh6Aiopc","marked":"_3tIQaxDr7OFW2fPsiLAjJ-","icon":"_2JiLegkc3RlrmcSEGmwgFl","disabled":"e4dGoIb4ppC3HF-Ji8iy7","disabledDate":"ISl7gI-woJsXNSWnSB6hP","theme-light":"_1jB9Gt4_depnxTiB_xDiSe"};


//////////////////
// WEBPACK FOOTER
// ./src/v2SPRINTA/molecules/Calendar/style.module.css
// module id = 507
// module chunks = 39